import FrenchFlag from './FrenchFlag';
import { StyledAllLanguagesFlag } from './LanguageFlag.styled';
import SpanishFlag from './SpanishFlag';

export default function AllLanguagesFlag() {
  return (
    <StyledAllLanguagesFlag>
      <SpanishFlag />
      <FrenchFlag />
    </StyledAllLanguagesFlag>
  );
}
